




























































import Vue from 'vue';
import { mapGetters, mapActions } from 'vuex';

import ShowList from '../show-list/show-list.vue';

export default Vue.extend({
  name: 'AppBar',

  components: {
    ShowList,
  },

  computed: {
    ...mapGetters('user', [
      'isLoggedIn',
    ]),

    landingPage() {
      return this.$route.name === 'Landing';
    },
  },

  data: () => ({
    searchOpen: false,
  }),

  methods: {
    ...mapActions('user', [
      'toggleNavBar',
    ]),

    goHome() {
      if (this.isLoggedIn) {
        this.$router.push('/home');
      } else {
        this.$router.push('/');
      }
    },

    loginPage() {
      this.$router.push('/login');
    },

    open() {
      this.searchOpen = true;
    },

    close() {
      this.searchOpen = false;
    },
  },
});
